// extracted by mini-css-extract-plugin
export var container = "SwiperSlider-module--container--8ee8c";
export var navButton = "SwiperSlider-module--navButton--6befd";
export var slide = "SwiperSlider-module--slide--ecb56";
export var slideContent = "SwiperSlider-module--slideContent--f2729";
export var slideCopy = "SwiperSlider-module--slideCopy--7ff52";
export var slideHeading = "SwiperSlider-module--slideHeading--e3903";
export var slideInner = "SwiperSlider-module--slideInner--425d3";
export var slideMedia = "SwiperSlider-module--slideMedia--8dc22";
export var slider = "SwiperSlider-module--slider--d39d5";
export var swiper = "SwiperSlider-module--swiper--07961";